import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Loader2, ArrowLeft, ShieldCheck } from "lucide-react";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-green grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between p-12 text-brand-cream">
        <a href="/" className="flex items-center gap-2 text-brand-cream/70 hover:text-brand-cream transition-colors text-sm">
          <ArrowLeft className="h-4 w-4" /> Back to site
        </a>
        <div>
          <ShieldCheck className="h-10 w-10 text-brand-sand" />
          <h1 className="font-serif text-5xl mt-6 leading-tight">Agent<br />Dashboard.</h1>
          <p className="mt-4 text-brand-cream/70 max-w-sm">Manage incoming quote requests and contact messages from anicobr.com in one place.</p>
        </div>
        <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-brand-cream/50">Doug Jones Insurance and Financial Planning Agency · PDJ Insurance &amp; Financial Services Inc</span>
      </div>

      <div className="flex items-center justify-center bg-brand-cream p-6">
        <form onSubmit={submit} data-testid="login-form" className="w-full max-w-sm">
          <span className="overline">Secure sign in</span>
          <h2 className="font-serif text-4xl text-brand-ink mt-3 mb-8">Welcome back.</h2>
          <div className="space-y-4">
            <div className="space-y-1.5">
              <span className="font-mono text-[11px] uppercase tracking-[0.15em] text-brand-moss">Email</span>
              <Input data-testid="login-email-input" type="email" value={email}
                onChange={(e) => setEmail(e.target.value)} placeholder="admin@anicobr.com" className="bg-white border-brand-line" />
            </div>
            <div className="space-y-1.5">
              <span className="font-mono text-[11px] uppercase tracking-[0.15em] text-brand-moss">Password</span>
              <Input data-testid="login-password-input" type="password" value={password}
                onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="bg-white border-brand-line" />
            </div>
            <button type="submit" disabled={loading} data-testid="login-submit-btn"
              className="w-full rounded-full bg-brand-green text-brand-cream font-medium py-3.5 flex items-center justify-center gap-2 hover:bg-brand-ink active:scale-95 transition-all disabled:opacity-60">
              {loading && <Loader2 className="h-4 w-4 animate-spin" />} Sign In
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
